// extracted by mini-css-extract-plugin
export var actionIcon = "_uv-0";